import ReservationSpecialBusinessTime from "./ReservationSpecialBusinessTime";

export default class ReservationSpecialBusinessTimes {
  constructor(private readonly _list: ReservationSpecialBusinessTime[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public has(index: number): boolean {
    return !!this._list[index];
  }

  public toList(): ReservationSpecialBusinessTime[] {
    return this.isEmpty() ? [] : this._list;
  }

  public findByIndex(index: number): ReservationSpecialBusinessTime {
    if (this.isEmpty() || !this.has(index)) return new ReservationSpecialBusinessTime();
    return this._list[index];
  }

  public replace(index: number, specialBusinessTime: ReservationSpecialBusinessTime): ReservationSpecialBusinessTimes {
    if (this.isEmpty() || !this.has(index)) return new ReservationSpecialBusinessTimes();
    this._list[index] = specialBusinessTime;
    return new ReservationSpecialBusinessTimes(this._list);
  }

  public add(specialBusinessTime: ReservationSpecialBusinessTime): ReservationSpecialBusinessTimes {
    this._list.push(specialBusinessTime);
    return new ReservationSpecialBusinessTimes(this._list);
  }

  public delete(index: number): ReservationSpecialBusinessTimes {
    if (this.isEmpty() || !this.has(index)) return new ReservationSpecialBusinessTimes(this._list);
    this._list.splice(index, 1);
    return new ReservationSpecialBusinessTimes(this._list);
  }

  public size(): number {
    return this._list.length;
  }
}